import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, ResourceInfoPageModelState } from '@/models/connect';
import {
  ChangeAction,
  OnUnmount_Page_Action,
  OnMount_Page_Action,
  OnClick_SaveIntroductionBtn_Action,
  OnChange_Labels_Action,
  OnChange_Cover_Action,
  OnClick_EditTitleBtn_Action,
  OnClick_CancelEditTitleBtn_Action,
  OnClick_SaveTitleBtn_Action,
  OnChange_TitleInput_Action,
} from '@/models/resourceInfoPage';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
  ResourceSiderModelState,
} from '@/models/resourceSider';
import { Helmet } from 'react-helmet';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FSkeletonNode from '@/components/FSkeletonNode';
import * as AHooks from 'ahooks';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
// import { history } from '@@/core/history';
import FPrompt from '@/components/FPrompt';
import { history } from '@@/core/history';
import { useParams } from 'react-router-dom';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import ResourceLabelsCard from '@/components/FResourceLabelsCard';
import FCoverImageEditor from '@/components/FCoverImageEditor';
import FIntroductionInput from '@/components/FIntroductionInput';
// import FPolicyBuilderDrawer3 from '@/components/FPolicyBuilderDrawer3';

interface InfoProps {
  dispatch: Dispatch;
  resourceInfoPage: ResourceInfoPageModelState;
  resourceSider: ResourceSiderModelState;
}

function Info({ dispatch, resourceInfoPage, resourceSider }: InfoProps) {
  const params = useParams<{ id: string }>();
  const [$isEditing_Introduction, set$isEditing_Introduction, get$isEditing_Introduction] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });
    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'info',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceInfoPage/onMount_Page',
      payload: {
        resourceID: params.id!,
        // pageState: 'loading',
      },
    });
  });

  AHooks.useUnmount(async () => {
    await dispatch<OnUnmount_Page_Action>({
      type: 'resourceInfoPage/onUnmount_Page',
    });
  });

  return (
    <>
      <FPrompt
        watch={resourceInfoPage.title_IsEditing || $isEditing_Introduction}
        onOk={(locationHref) => {
          history.push(locationHref);
        }}
      />

      <Helmet>
        <title>{`资源信息 · ${
          resourceInfoPage.resourceInfo?.resourceName || ''
        }  - Freelog`}</title>
      </Helmet>
      {resourceInfoPage.pageState === 'loading' && (
        <div className={styles.root}>
          <div className={styles.skeleton}>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          </div>
        </div>
      )}

      {!!resourceInfoPage.resourceInfo && resourceInfoPage.pageState === 'loaded' && (
        <div className={styles.root}>
          <div style={{ height: 40 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                text={
                  // 资源授权标识
                  FI18n.i18nNext.t('edit_resource_listing_authid')
                }
                type={'highlight'}
              />
              <FCopyToClipboard
                text={resourceInfoPage.resourceInfo.resourceName}
                title={
                  // 复制
                  FI18n.i18nNext.t('edit_resource_listing_btn_copy')
                }
              >
                <FComponentsLib.FTextBtn type={'primary'} style={{ fontSize: 12 }}>
                  {
                    // 复制
                    FI18n.i18nNext.tAuto('edit_resource_listing_btn_copy')
                  }
                </FComponentsLib.FTextBtn>
              </FCopyToClipboard>
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              text={
                // 此资源在整个授权系统中的唯一标识符，一旦创建则不能更改。
                FI18n.i18nNext.t('edit_resource_listing_authid_info')
              }
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            <div className={styles.resourceTitle} style={{ justifyContent: 'space-between' }}>
              <FComponentsLib.FContentText
                text={resourceInfoPage.resourceInfo.resourceName}
                type={'normal'}
              />

              <FIcons.FLock style={{ color: '#999', fontSize: 14 }} />
            </div>
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                text={
                  // 资源标题
                  FI18n.i18nNext.t('edit_resource_listing_title')
                }
                type={'highlight'}
              />

              {resourceInfoPage.title_IsEditing && (
                <Space size={10}>
                  <FComponentsLib.FTextBtn
                    type={'default'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      dispatch<OnClick_CancelEditTitleBtn_Action>({
                        type: 'resourceInfoPage/onClick_CancelEditTitleBtn',
                      });
                    }}
                  >
                    {
                      // 取消
                      FI18n.i18nNext.tAuto('btn_cancel')
                    }
                  </FComponentsLib.FTextBtn>
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    disabled={
                      resourceInfoPage.title_Input === '' ||
                      resourceInfoPage.title_Input.length > 100
                    }
                    type={'primary'}
                    onClick={() => {
                      dispatch<OnClick_SaveTitleBtn_Action>({
                        type: 'resourceInfoPage/onClick_SaveEditTitleBtn',
                        payload: {
                          trigger: 'resource',
                        },
                      });
                    }}
                  >
                    {
                      // 保存
                      FI18n.i18nNext.tAuto('btn_save')
                    }
                  </FComponentsLib.FTextBtn>
                </Space>
              )}

              {!resourceInfoPage.title_IsEditing && (
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  style={{ fontSize: 12 }}
                  disabled={resourceInfoPage.isRssRelated}
                  onClick={() => {
                    dispatch<OnClick_EditTitleBtn_Action>({
                      type: 'resourceInfoPage/onClick_EditTitleBtn',
                    });
                  }}
                >
                  {
                    // 编辑
                    FI18n.i18nNext.tAuto('edit_resource_listing_btn_edit')
                  }
                </FComponentsLib.FTextBtn>
              )}
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t(
                // 标题直接影响商品的搜索曝光机会，建议在标题中加入品牌/内容主旨，例如，《大明风华：明朝人的城市生活》；标题长度不超过100个字符。
                'edit_resource_listing_title_info',
              )}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            {resourceInfoPage.title_IsEditing && (
              <>
                <FInput_PinyinSafeTextCounter
                  value={resourceInfoPage.title_Input || ''}
                  lengthLimit={100}
                  style={{ width: '100%' }}
                  placeholder={FI18n.i18nNext.t('cqr_input_title_hint')}
                  onChangeValue={(v) => {
                    dispatch<OnChange_TitleInput_Action>({
                      type: 'resourceInfoPage/onChange_TitleInput',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  hasError={resourceInfoPage.title_Error !== ''}
                />
                {resourceInfoPage.title_Error !== '' && (
                  <>
                    <div style={{ height: 5 }} />
                    <div style={{ color: '#EE4040' }}>{resourceInfoPage.title_Error}</div>
                  </>
                )}
              </>
            )}

            {!resourceInfoPage.title_IsEditing && (
              <div className={styles.resourceTitle}>
                <FComponentsLib.FContentText
                  text={
                    resourceInfoPage.resourceInfo.resourceTitle ||
                    resourceInfoPage.resourceInfo.resourceName.split('/')[1] ||
                    ''
                  }
                  type={'normal'}
                />
              </div>
            )}
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image')}
              type={'highlight'}
            />
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image_help')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />

            <FCoverImageEditor
              lodding={!!resourceSider.resourceCoverParsingSha1}
              src={resourceSider.resourceCover || ''}
              use={'resource'}
              width={200}
              disabled={resourceInfoPage.isRssRelated}
              onChange={(url) => {
                dispatch<OnChange_Cover_Action>({
                  type: 'resourceInfoPage/onChange_Cover',
                  payload: {
                    value: url,
                    trigger: 'resource',
                  },
                });
              }}
            />
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.introductionWrap}>
            <FIntroductionInput
              className={styles.introductionBlock}
              disabled={resourceInfoPage.isRssRelated}
              value={resourceInfoPage.introduction_EditorText}
              title={FI18n.i18nNext.t('resource_short_description')}
              tip={FI18n.i18nNext.t('listing_description_info')}
              btnText={FI18n.i18nNext.t('listing_description_btn')}
              onOK={async (value: string) => {
                await dispatch<ChangeAction>({
                  type: 'resourceInfoPage/change',
                  payload: {
                    introduction_EditorText: value,
                  },
                });
                await dispatch<OnClick_SaveIntroductionBtn_Action>({
                  type: 'resourceInfoPage/onClick_SaveIntroductionBtn',
                });
              }}
              onEditingChange={(isEditing: boolean) => {
                set$isEditing_Introduction(isEditing);
              }}
            />
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={
                // 标签
                FI18n.i18nNext.t('resource_tag')
              }
              type={'highlight'}
            />
            <div style={{ height: 20 }} />

            {resourceInfoPage.resourceInfo.tags.length === 0 && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <FComponentsLib.FContentText
                  text={
                    // 标签是描述型关键字，添加标签有助于人们找到您的资源。
                    FI18n.i18nNext.t('rqr_input_resouce_tag_empty_msg')
                  }
                  type={'additional2'}
                />

                <div style={{ height: 20 }} />
                <FComponentsLib.FRectBtn
                  type='primary'
                  onClick={async () => {
                    const result: null | string[] = await fEditLabelsDrawer({
                      labels: [],
                      resourceTypeCode:
                        resourceInfoPage.resourceInfo?.resourceTypeCode || undefined,
                    });
                    if (result === null) {
                      return;
                    }

                    dispatch<OnChange_Labels_Action>({
                      type: 'resourceInfoPage/onChange_Labels',
                      payload: {
                        value: result,
                      },
                    });
                  }}
                >
                  {
                    // 添加标签
                    FI18n.i18nNext.tAuto('rqr_input_resouce_tag_empty_btn')
                  }
                </FComponentsLib.FRectBtn>
              </div>
            )}
            {resourceInfoPage.resourceInfo.tags.length > 0 && (
              <ResourceLabelsCard
                labels={resourceInfoPage.resourceInfo?.tags || []}
                onClick={async () => {
                  const result: null | string[] = await fEditLabelsDrawer({
                    labels: resourceInfoPage.resourceInfo?.tags || [],
                    resourceTypeCode: resourceInfoPage.resourceInfo?.resourceTypeCode || undefined,
                  });
                  if (result === null) {
                    return;
                  }

                  dispatch<OnChange_Labels_Action>({
                    type: 'resourceInfoPage/onChange_Labels',
                    payload: {
                      value: result,
                    },
                  });
                }}
              />
            )}

            {/* {resourceInfoPage.resourceInfo.tags.length > 0 && (
              <div
                className={styles.ResourceLabelsCard_hasData}
                onClick={async () => {
                  const result: null | string[] = await fEditLabelsDrawer({
                    labels: resourceInfoPage.resourceInfo?.tags || [],
                    resourceTypeCode: resourceInfoPage.resourceInfo?.resourceTypeCode || undefined,
                  });
                  if (result === null) {
                    return;
                  }

                  dispatch<OnChange_Labels_Action>({
                    type: 'resourceInfoPage/onChange_Labels',
                    payload: {
                      value: result,
                    },
                  });
                }}
                // style={style}
              >
                {resourceInfoPage.resourceInfo.tags.map((l, li) => {
                  return <label key={li}>{l}</label>;
                })}
              </div>
            )} */}
          </div>

          <div style={{ height: 100 }} />
        </div>
      )}

      {/* <FPolicyBuilderDrawer3 /> */}
    </>
  );
}

export default connect(({ resourceInfoPage, resourceSider }: ConnectState) => ({
  resourceSider: resourceSider,
  resourceInfoPage: resourceInfoPage,
}))(Info);

// function ResourceLabelsCard({ labels }: { labels: string[] }) {
//   return (
//     <div className={styles.ResourceLabelsCard_hasData}>
//       {labels.map((l, li) => {
//         return <label key={li}>{l}</label>;
//       })}
//     </div>
//   );
// }
